import * as types from './dashboardTypes';

const initialState = {
    companies: [],
    inbox: {
        data: [],
        status: null,
        chart: null,
    },
    project: {
        reports: [],
    },
    expense: {
        reports: [],
    },
    documents: {
        reports: [],
    },
    summary: {
        totalBudget: 0,
        actualExpense: 0,
        remainingBudget: 0,
        invoicesProcessed: 0,
        pendingGRNs: 0,
        pendingPOs: 0,
    },
    loading: false,
    error: null,
};

const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_COMPANIES:
            return { ...state, companies: action.payload || [] };
        case types.SET_INBOX_DATA: {
            const invoicesProcessed = action.payload.data?.length || 0;
            return {
                ...state,
                inbox: action.payload,
                summary: {
                    ...state.summary,
                    invoicesProcessed
                }
            };
        }
        case types.SET_PROJECT_DATA: {
            const reports = action.payload;
            const totalBudget = reports.reduce((sum, item) => sum + (item.Budget || 0), 0);
            const actualExpense = reports.reduce((sum, item) => sum + (item.Actuals || 0), 0);
            const remainingBudget = totalBudget - actualExpense;
            return {
                ...state,
                project: { ...state.project, reports },
                summary: {
                    ...state.summary,
                    totalBudget,
                    actualExpense,
                    remainingBudget
                }
            };
        }
        case types.SET_EXPENSE_DATA:
            return { ...state, expense: { ...state.expense, reports: action.payload || [] } };
        case types.SET_DOCUMENTS_DATA:
            return { ...state, documents: { ...state.documents, reports: action.payload || [] } };
        case types.SET_SUMMARY_STATS:
            return { ...state, summary: action.payload };
        case types.SET_DASHBOARD_LOADING:
            return { ...state, loading: action.payload };
        case types.SET_DASHBOARD_ERROR:
            return { ...state, error: action.payload };
        default:
            return state;
    }
};

export default dashboardReducer;
